import { CommonModule } from '@angular/common';
import {
  Component,
  ViewChildren,
  QueryList,
  ElementRef,
  Input,
  AfterViewInit,
} from '@angular/core';
import { GsapSplitTextOnScrollDirective } from '../../core/directives/gsap-split-text-on-scroll.directive';

import { FaqItem } from '../../core/interface/faq.modal';
@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
  standalone: true,
  imports: [CommonModule, GsapSplitTextOnScrollDirective],
})
export class FaqsComponent implements AfterViewInit {
  @Input({ required: true }) faqs!: FaqItem[];
  @Input() theme!: string;

  contentHeights: number[] = [];
  activeIndex: number | null = 0;
  private readonly BASE_DELAY: number = 0.2;
  private readonly INCREMENT_STEP: number = 0.2;

  @ViewChildren('contentRef') contentRefs!: QueryList<ElementRef>;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.contentHeights = this.contentRefs.map((ref) => ref.nativeElement.scrollHeight);
    });
  }

  calculateDelay(index: number): number {
    return this.BASE_DELAY + index * this.INCREMENT_STEP;
  }

  toggleFAQ(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
}
